// The single source of truth for delivery facts in marketing copy.
//
// Copy only — the schedule the app actually enforces lives in
// constants/meals.js (DELIVERY_DAYS, LOCK_HOURS) and utils/deliveryDates.js.
// The cutoff strings below are written to match those, because they used to
// drift: several pages promised a "2pm Saturday" cutoff the code never honoured
// and a "Wednesday" cutoff that does not exist.

export const DELIVERY = {
  /** The primary window, as it should read everywhere. */
  days: 'Sundays and Mondays, 5–10pm',
  /** The secondary slot, kept where a page already offered it. */
  also: 'Thursdays midday',
  /** One sentence, for prose. */
  line: 'We deliver on Sundays and Mondays between 5–10pm, and Thursdays midday.',
  /** Same fact as a label, for spec lists and hero subtitles. */
  short: 'Sundays and Mondays 5–10pm, Thursdays midday',
  zones: 'Brooklyn, Manhattan, Long Island City, Long Island, Jersey City, Hoboken and Westchester',
  /** Order-by times, mirroring LOCK_HOURS in constants/meals.js. */
  cutoffs: [
    'Order by 8pm on Friday for a Sunday evening delivery',
    'Order by 12pm on Saturday for a Monday evening delivery',
    'Order by 12pm on Tuesday for a Thursday midday delivery',
  ],
  /** The same, as one sentence. */
  cutoffLine: 'Order by 8pm Friday for a Sunday delivery, 12pm Saturday for a Monday delivery, or 12pm Tuesday for a Thursday delivery.',
  /** When the week's personalized menu goes out. */
  menuDay: 'We share your personalized menu by email every Wednesday.',
  /** Deadline for swaps and customizations. */
  changes: 'Substitutions and customizations are welcome — just email your request by 12pm Saturday.',
};

export default DELIVERY;
